import { apiClient } from "../utils/apiClient";

export const announcementApi = {
    // ---- Listeleme (Admin) ----
    async list(params = {}) {
        const qs = new URLSearchParams();
        if (params.isActive !== undefined && params.isActive !== null) {
            qs.append("isActive", params.isActive ? "true" : "false");
        }

        const endpoint = qs.toString()
            ? `Announcements?${qs.toString()}`
            : `Announcements`;

        return await apiClient(endpoint, { method: "GET" });
    },

    // ---- Detay Getirme ----
    async getById(id) {
        return await apiClient(`Announcements/${id}`, { method: "GET" });
    },

    // ---- Oluşturma ----
    async create(dto) {
        return await apiClient("Announcements", { method: "POST", body: dto });
    },

    // ---- Güncelleme ----
    async update(id, dto) {
        return await apiClient(`Announcements/${id}`, { method: "PUT", body: dto });
    },

    // ---- Durum Değiştirme (Aktif/Pasif) ----
    async toggleActive(id) {
        return await apiClient(`Announcements/${id}/toggle-active`, { method: "PATCH" });
    },

    // ---- Başa Tutturma Değiştirme (Pin/Unpin) ----
    async togglePinned(id) {
        return await apiClient(`Announcements/${id}/toggle-pinned`, { method: "PATCH" });
    },

    // ---- Silme ----
    async remove(id) {
        return await apiClient(`Announcements/${id}`, { method: "DELETE" });
    },

    // ---- Dashboard (Kullanıcıya özel) ----
    async getDashboardAnnouncements(limit = 5) {
        return await apiClient(`Announcements/dashboard?limit=${limit}`, { method: "GET" });
    }
};

export default announcementApi;
